import React from 'react';
import { FaMale, FaFemale, FaChild, FaSocks, FaBox, FaList } from 'react-icons/fa';

const Hero = ({ typ }) => {
  return (
    <div className="py-8 bg-gradient-to-r from-indigo-50 to-purple-50">
      <section className="text-[#212529] flex flex-col items-center justify-center min-h-[60vh]">
        {/* Heading and Subheading */}
        <div className="text-center mb-8">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            Comfortable and Stylish Socks
          </h2>
          <p className="text-lg lg:text-xl text-gray-600">
            Find the perfect pair of socks for any occasion.
          </p>
        </div>

        {/* Button Group */}
        <div className="flex flex-col items-center">
          <h3 className="text-xl font-semibold text-gray-700 mb-4">
            Shop by Category
          </h3>
          <div className="flex flex-wrap justify-center gap-3">
            <button
              onClick={() => typ('men')}
              className="flex items-center justify-center px-4 py-2 bg-indigo-600 text-white font-medium rounded-md shadow-sm hover:bg-indigo-700 transition-all duration-200 transform hover:scale-105"
            >
              <FaMale className="mr-2" /> Men
            </button>
            <button
              onClick={() => typ('women')}
              className="flex items-center justify-center px-4 py-2 bg-indigo-600 text-white font-medium rounded-md shadow-sm hover:bg-indigo-700 transition-all duration-200 transform hover:scale-105"
            >
              <FaFemale className="mr-2" /> Women
            </button>
            <button
              onClick={() => typ('kids')}
              className="flex items-center justify-center px-4 py-2 bg-indigo-600 text-white font-medium rounded-md shadow-sm hover:bg-indigo-700 transition-all duration-200 transform hover:scale-105"
            >
              <FaChild className="mr-2" /> Kids
            </button>
            <button
              onClick={() => typ('onesize')}
              className="flex items-center justify-center px-4 py-2 bg-indigo-600 text-white font-medium rounded-md shadow-sm hover:bg-indigo-700 transition-all duration-200 transform hover:scale-105"
            >
              <FaSocks className="mr-2" /> Onesize
            </button>
            <button
              onClick={() => typ('box')}
              className="flex items-center justify-center px-4 py-2 bg-indigo-600 text-white font-medium rounded-md shadow-sm hover:bg-indigo-700 transition-all duration-200 transform hover:scale-105"
            >
              <FaBox className="mr-2" /> Box
            </button>
            <button
              onClick={() => typ('')}
              className="flex items-center justify-center px-4 py-2 bg-gray-600 text-white font-medium rounded-md shadow-sm hover:bg-gray-700 transition-all duration-200 transform hover:scale-105"
            >
              <FaList className="mr-2" /> Show All
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Hero;